import React, { useEffect, useState } from 'react';
import { Form, PageItem, Pagination } from 'react-bootstrap';
import PaginationProp from './properties/pagination';
import './scss/pagination-nova.scss';

function PaginationNova({ itemCount, reset, onPageClick }: PaginationProp): React.ReactElement {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    if (reset) {
      setCurrentPage(1);
    }
  }, [reset]);

  useEffect(() => {
    onPageClick(pageSize, currentPage);
  }, [pageSize, currentPage]);

  return (
    <div className="pagination row">
      <div className="col-6">
        <Form.Select
          aria-label="Select Page Size"
          value={pageSize}
          onChange={(e) => { setPageSize(Number(e.target.value)); setCurrentPage(1); }}
          className="w-30"
          style={{ width: '90px' }}
        >
          <option value="10" key="10">10</option>
          <option value="50" key="50">50</option>
          <option value="100" key="100">100</option>
          <option value="500" key="500">500</option>
        </Form.Select>
      </div>
      <div className="col-6">
        <Pagination className="float-end">
          { currentPage > 1 ? (
            <Pagination.First
              onClick={() => setCurrentPage(1)}
            />
          ) : ''}
          { currentPage > 1 ? (
            <Pagination.Prev
              onClick={() => setCurrentPage(currentPage - 1)}
            />
          ) : ''}
          {itemCount <= pageSize && currentPage === 1 ? '' : <PageItem className="text-center">{currentPage}</PageItem>}
          {itemCount > pageSize ? (
            <Pagination.Next
              onClick={() => setCurrentPage(currentPage + 1)}
            />
          ) : '' }
        </Pagination>
      </div>
    </div>
  );
}

export default PaginationNova;
